<template>
    <div id="baseFooter">
        <transition name="slide">
        <div class="trade-bottom-box" v-if="!hideFooter_">
            <!--买入-->
            <div class="wrap-btom">
                <bottom-head @hideFooter="hideFooter(true)" @bottomTabChange="bTabChange($event)"></bottom-head>
                <bottom-deal :price="price_"
                             :type="bTabIndex" :class="'deal_' + bTabIndex"
                             v-if="bTabIndex < 2"></bottom-deal>
                <bottom-price-grade @setPrice="setPrice($event)" v-if="bTabIndex < 2"></bottom-price-grade>
                <bottom-positions v-if="bTabIndex < 2"></bottom-positions>
                <bottom-cancel-order v-if="bTabIndex == 2"></bottom-cancel-order>
                <bottom-query v-if="bTabIndex == 3"></bottom-query>
            </div>

            <div class="banben">
                <div class="ban-t">版本:<span class="green"> v{{version}}</span></div>
                <div class="ban-t">交易服务:<span class="green"> 已连接</span></div>
                <div class="ban-t">行情服务:<span class="green"> 已连接</span></div>
            </div>
        </div>
        </transition>
        <transition name="slide">
        <div class="for-bottom-box" v-if="hideFooter_">
            <div class="bot-head-rgt flot">
                <div class="bot-box1">
                    <img src="~@/assets/images/zichan@3x.png"/>总资产:{{account_info?account_info.all_money:'-'}}
                </div>
                <div class="bot-box1">
                    <img src="~@/assets/images/money@3x.png"/>可用资金:{{account_info?account_info.can_money:'-'}}
                </div>
            </div>
            <div class="bot-img2" @click="hideFooter(false)"><img src="~@/assets/images/zuidahua.png"/></div>
        </div>
        </transition>
    </div>
</template>

<script>
    import BaseFooterHeader from './BaseFooterHeader';
    import BaseFooterDeal from './BaseFooterDeal';
    import BaseFooterPriceGrade from './BaseFooterPriceGrade';
    import BaseFooterPositions from './BaseFooterPositions';
    import BaseFooterCancelTheOrder from './BaseFooterCancelTheOrder';
    import BaseFooterQuery from './BaseFooterQuery';
    import BaseFooterBaseApi from './BaseFooterBaseApi'
    import config from '../../../package.json'

    export default {
        name: "BaseFooter",
        components: {
            'bottom-head': BaseFooterHeader,
            'bottom-deal': BaseFooterDeal,
            'bottom-price-grade': BaseFooterPriceGrade,
            'bottom-positions': BaseFooterPositions,
            'bottom-cancel-order': BaseFooterCancelTheOrder,
            'bottom-query': BaseFooterQuery,
        },
        data: function () {
            return {
                version: config.version,
                bTabIndex: 0,
                hideFooter_: false,
                price_: null,
                intervalHand: null
            }
        },
        mounted() {
            this.getaccountinfo();
        },
        computed: {
            isopen() {
              return this.$store.state.isopen;
            },
            token: function () {
                return this.$store.state.now_token;
            },
            userName: function () {
                return this.$store.state.now_trade_account;
            },
            account_info: function () {
                if(this.$store.state.account_info) {
                    return this.$store.state.account_info
                }
                return null;
            }
        },
        watch: {
            token: function (value, ov) {
                if (value !== ov) {
                    this.getaccountinfo();
                }
            },
            // 交易账户信息需要更新
            '$store.state.account_info_need_up': function () {
                this.getaccountinfo();
            },
            isopen(v) {
                if(v) {
                    this.getaccountinfo();
                }
            }
        },
        methods: {
            bTabChange(bTabIndex) {
                this.bTabIndex = bTabIndex;
            },
            hideFooter(yes) {
                this.hideFooter_ = yes;
                this.$store.commit('HIDE_FOOTER', {
                    show: yes,
                    time: new Date().getTime()
                });
            },
            setPrice($event) {
                this.price_ = $event;
            },
            ...BaseFooterBaseApi
        }

    }
</script>

<style scoped>
    .slide-enter-active, .slide-leave-active {
        transition: height .3s;
    }
    .slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
        transform: translateY(380px);
    }
    .trade-bottom-box {
        transition: all 0.3s;
    }

</style>
